import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import styleObj from "../style.module.scss";
import styleObj2021 from "./style.module.scss";
import Dialog from "../../dialog";

function getStatus(status) {
  switch (status) {
    case 0:
      return "(未开始)";
    case 1:
      return "(报名中)";
    default:
      return "";
  }
}
export default class MyNav extends Component {
  preventClick(e, isPrevent) {
    console.log("isPrevent: ", isPrevent);

    if (isPrevent) {
      Dialog("活动尚未开始，敬请期待~").show();
      e.preventDefault();
      // window.open('http://www.jiguo.com/event/index/3706.html','__target')
    }
  }
  render() {
    const { list } = this.props;
    return (
      <div className={`${styleObj["nav-wrap"]} ${styleObj2021["nav-wrap"]}`}>
        <div className={`${styleObj["nav"]} ${styleObj2021["nav"]}`}>
          <div className={styleObj2021["nav-header"]}>
            <img src={require("../../../assets/imgs/nav-header.png")} />
          </div>
          {list.map((item) => (
            <NavLink
              key={item.path}
              exact
              to={item.path}
              className={item.status === 0 ? styleObj2021["will-open"] : ""}
              activeClassName={`${styleObj["on"]} ${styleObj2021["on"]}`}
              onClick={(e) => {
                this.preventClick(e, item.isPrevent);
              }}
            >
              <p>{item.name}</p>
              {
                <p className={styleObj["status"]}>
                  {item.timeEnd ? item.timeEnd.split(" ")[0] : ""}
                </p>
              }
              <p className={styleObj["status"]}>{getStatus(item.status)}</p>
            </NavLink>
          ))}
        </div>
      </div>
    );
  }
}
